import { Box, TextField } from "@mui/material";
import React from "react";
import { Controller, useFormState } from "react-hook-form";

const TextInput = ({
  name,
  label,
  control,
  Icon,
  alignItems,
  mb,
  showLabel = true,
  ...props
}) => {
  const { errors } = useFormState({ control, name: name });
  const error = errors[name]?.message;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: alignItems || "flex-end",
            width: "100%",
            marginBottom: mb || "1.2em",
          }}
        >
          {Icon && (
            <Icon
              sx={{
                color: "var(--primary-color)",
                marginInlineEnd: 1,
                my: 0.5,
              }}
            />
          )}
          <TextField
            label={showLabel && label}
            variant={props.variant || "standard"}
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderWidth: "1px",
                  borderRadius: "8px",
                },
                "&:hover fieldset": {
                  borderColor: "var(--primary-color)",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "var(--primary-color)",
                  borderWidth: "2px",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "var(--primary-color)",
              },
            }}
            error={error ? true : false}
            helperText={error}
            {...props}
            {...field}
          />
        </Box>
      )}
    />
  );
};

export default TextInput;
